// extracted by mini-css-extract-plugin
module.exports = {"widgetContainer":"styles_widgetContainer__1mMvW","countryTitle":"styles_countryTitle__1FCSz"};